import { render, staticRenderFns } from "./LeaveManageAdmin.vue?vue&type=template&id=485ccbb0&scoped=true"
import script from "./LeaveManageAdmin.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdmin.ts?vue&type=script&lang=ts&external"
import style0 from "./LeaveManageAdmin.vue?vue&type=style&index=0&id=485ccbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ccbb0",
  null
  
)

export default component.exports